<template>
  <div class="card shadow px-2 m-0">
    <a id="button"></a>
    <div class="card-header bg-transparent p-3">
      <h3>
        {{ $t("message.add") }} {{ $tc("message.EtablissementPrix", 1) }}
      </h3>
    </div>
    <b-container fluid class="p-0 m-0">
      <b-row class="justify-content-sm-center">
        <b-col sm="6">
          <!-- <span class="obligatoire">*</span> -->
          <b-form-group
            id="institution-group"
            label=""
            label-for="institution"
          >
            <select
              id="institution"
              v-model="$v.form.institution.$model"
              @change="getComplementaire"
              class="form-control is-invalid retirerBordure"
              required
            >
              <option data-placeholder="true"></option>
              <option
                v-for="item in mInstitutions"
                :key="item.id"
                :value="item.id"
              >
                {{ item.nom }}
              </option>
            </select>
            <b-form-invalid-feedback v-if="$v.form.institution.$error">
              {{ $t("message.requiredField") }}
            </b-form-invalid-feedback>
            <span
              v-if="errorshasField('etablissement_id')"
              style="color: red"
            >
              {{ getErrorsField("etablissement_id") }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="4" md="4" class="my-1">
          <b-form-group
            label="Filter"
            label-for="filter-input"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              ></b-form-input>

              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col lg="4" md="4" class="my-1" >
          <b-form-group
            label="Per page"
            label-for="per-page-select"
            label-cols-sm="6"
            label-cols-md="4"
            label-cols-lg="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col lg="4" md="4" class="my-1" >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
        <div v-if="!mobileView">
          <b-table
            v-if="isList"
            :items="etablissementExamens"
            :fields="fields1"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            stacked="md"
            show-empty
            small
            @filtered="onFiltered">
            <template #cell(prix)="row">
              <span v-if="!row.item.editing">
                {{ row.item.prix }}
              </span>
              <span class="" v-else>
                <b-form-input type="text" v-model="row.item.prix" />
              </span>
            </template>
            <template #cell(action)="data">
              <b-button
                @click="doEdit(data.item)"
                v-if="!data.item.editing"
                variant="success">
                {{ $t("message.edit") }}
              </b-button>
              <b-button @click="doSave(data.item)" v-else variant="success">
                {{ $t("message.save") }}
              </b-button>
            </template>
          </b-table>

          <b-table
            :items="defaultExamenPrix"
            :fields="fields"
            :filter="filter"
            :current-page="currentPage"
            :per-page="perPage"
            :filter-included-fields="filterOn"
            v-else-if="isSave">
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(prix)="data">
              <b-form-input type="text" v-model="data.item.prix" />
            </template>
          </b-table>
        </div>
        <div v-else>
          <div v-if="isList">
            <div v-for="(examen, x) in etablissementExamens" :key="x+'page'" class="mt-3">
              <div class="list-group-item"><p class="ligne"><span class="new-title">Examen</span>: <span class="font-weight-bold text-gray">{{ examen.examen_complementaire.fr_description }}</span></p></div>
              <div class="list-group-item"><p class="ligne"><span class="new-title">Code</span><span class="font-weight-bold text-gray">{{ examen.examen_complementaire.slug }}</span></p></div>
              <div class="list-group-item"><p class="ligne"><span class="new-title">Famille</span>: <span class="font-weight-bold text-gray">{{ examen.examen_complementaire.reference }}</span></p></div>
              <div class="list-group-item"><p class="ligne"><span class="new-title">Prix</span>:
                <span v-if="!examen.editing" class="font-weight-bold text-gray">
                  {{ examen.prix }}
                </span>
                <span class="" v-else>
                  <b-form-input type="text" v-model="examen.prix" />
                </span></p>
              </div>
              <div class="list-group-item">
                <b-button
                  @click="doEdit(examen)"
                  v-if="!examen.editing"
                  variant="success">
                  {{ $t("message.edit") }}
                </b-button>
                <b-button @click="doSave(examen)" v-else variant="success">
                   {{ $t("message.save") }}
                </b-button>
              </div> 
            </div>
          </div>
          <div v-else-if="isSave">
            <div v-for="(examenprix, x) in defaultExamenPrix" :key="x+'-page'" class="mt-3">
              <div class="list-group-item"><p class="ligne"><span class="new-title">Examen</span>: <span class="font-weight-bold text-gray">{{ examenprix.fr_description }}</span></p></div>
              <div class="list-group-item"><p class="ligne"><span class="new-title">Code</span><span class="font-weight-bold text-gray">{{ examenprix.slug }}</span></p></div>
              <div class="list-group-item"><p class="ligne"><span class="new-title">Famille</span>: <span class="font-weight-bold text-gray">{{ examenprix.reference }}</span></p></div>
              <div class="list-group-item"><p class="ligne"><span class="new-title">Prix</span>: <span class="font-weight-bold text-gray">{{ examenprix.prix }}</span></p></div>
              <div class="list-group-item">
                <span class="">
                  <b-form-input type="text" v-model="examenprix.prix" />
                </span>
              </div> 
            </div>
          </div>
          
        </div>
     
      <b-row>
       <div class="col-12 text-center mt-3">
         <b-button @click="onSubmit" variant="primary" v-if="!isList">
          {{ $t("message.save") }}
        </b-button>
        <b-button @click="showAdd" variant="primary" v-if="can && isList && etablissementExamens.length<=0">
          {{ $t("message.add") }}
        </b-button>
       </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import _ from "lodash";
import SlimSelect from "slim-select";
import moment from "moment";
import $ from "jquery";
import Editor from "@tinymce/tinymce-vue";
import AppConfig from "../../constants/AppConfig";
import { pagination, handlePaginationClick } from "../../helpers/paginations";
import loading from "vue-loading-overlay";
// import * as ECT from '@whoicd/icd11ect';
// import '@whoicd/icd11ect/style.css';
export default {
  name: "AddGeneralMedicine",

  components: {
    editor: Editor,
    loading,
  },

  computed: {
    ...mapGetters([
      "practitioners",
      "controlDoctors",
      "reasons",
      "allergies",
      "institutions",
      "userInstitutions",
      "errors",
      "hasAdminRole",
      "hasMedecinControleRole",
      "hasPraticienRole",
      "Timelines",
      "etablissementExamens"
    ]),

    mInstitutions: function () {
      let iArray = [];

      _.forEach(
        _.orderBy(this.userInstitutions, ["created_at"], ["desc"]),
        function (institution) {
          let i = {};

          i.nom = institution.name;
          i.description = (
            !_.isNull(institution.description)
              ? institution.description.length > 20
              : false
          )
            ? institution.description.substr(0, 20) + "..."
            : institution.description;
          i.date = moment(institution.created_at).format("DD-MM-YYYY");
          i.id = institution.id;
          i.slug = institution.slug;

          iArray.push(i);
        }
      );

      return iArray;
    },

    can: function () {
      if (this.hasAdminRole) {
        return true;
      } else {
        return this.hasMedecinControleRole || this.hasPraticienRole;
      }
    },
  },

  data() {
    return {
      mobileView: true,
      complementaires: [],
      defaultExamenPrix: [],
      isList: true,
      isSave: false,
      complementaireChecked: [],
      complementaireUpdated: [],
      fields1: [
        { key: "examen_complementaire.fr_description", label: "examen" },
        { key: "examen_complementaire.slug", label: "code" },
        { key: "examen_complementaire.reference", label: "famille" },
        { key: "prix", label: "Prix" },
        { key: "action", label: "action" },
      ],
      fields: [
        { key: "fr_description", label: "examen" },
        { key: "slug", label: "code" },
        { key: "reference", label: "famille" },
        { key: "prix", label: "Prix" },
        { key: "action", label: "action" },
      ],
      form: {
        complementaire: [],
        institution:4,
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      show: true,
    };
  },
  methods: {
    handleView() {
      this.mobileView = window.innerWidth <= 990;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showAdd() {
      this.isList = false;
      this.isSave = true;
    },
    doSave(item) {
      this.$set(item, "editing", false);

      let args = {
        etablissement_id :this.form.institution,
        id:item.id,
        prix:item.prix
      }

      let successMessage = this.$i18n.t("message.ExamenUpdated");
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.genericError"), // TODO: Prendre message approprié
      };
      this.$store
        .dispatch("updateEtablissementExamen", {
          args: args,
          errorMessages,
          successMessage,
        });
    },
    doCancel(item) {
      this.$set(item, "editing", false);
      this.$delete(item, "temp");
    },
    doEdit(item) {
      this.$set(item, "editing", true);
    },
    sortingChanged(ctx) {
      // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
      // ctx.sortDesc ==> true if sorting descending, false otherwise
    },
    getUserInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit,
      };

      this.$store.dispatch("getUserInstitutions", {
        args: args,
      });
    },

    getInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit,
      };

      this.$store.dispatch("getInstitutions", {
        args: args,
      });
    },
    notEmpty(item) {
      return item.length > 0;
    },

    onSubmit: function (evt) {
      evt.preventDefault();

      this.$v.form.$touch();

      let args = {
        etablissement_id :this.form.institution,
        examen_complementaire:this.defaultExamenPrix
      }

      let successMessage = this.$i18n.t("message.ExamenCreated");
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.genericError"), // TODO: Prendre message approprié
      };
      this.$store
        .dispatch("createEtablissementPrice", {
          args: args,
          errorMessages,
          successMessage,
        })
        .then(() => {
            this.isList = true;
            this.isSave = false;
        });
    },

    onAllergieSubmit: function (evt) {
      evt.preventDefault();

      this.$v.allergiesForm.$touch();
    },

    onReset: function (evt) {
      evt.preventDefault();

      // Reset our form values
      this.form.complementaire = "";

      // Trick to reset/clear native browser form validation state
      this.show = false;

      this.$nextTick(() => {
        this.show = true;
      });
    },

    getErrorsField(field) {
      if (this.errorshasField(field)) {
        return this.errors[field][0];
      } else {
        return "";
      }
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      this.$store.dispatch("clearErrorField", {
        field,
      });

      this.getErrorsField(field);
    },
    getComplementaire: function () {
        let args = {
          institution :this.form.institution
        }

        let successMessage = this.$i18n.t("message.ExamenCreated");
        let errorMessages = {
          generic: this.$i18n.t("message.genericError"),
          error: this.$i18n.t("message.genericError"), // TODO: Prendre message approprié
        };
        this.$store
        .dispatch("getComplementaryExams", {
          args: args,
          errorMessages,
          successMessage,
        });
    },
    getPrice: function () {
      return fetch(AppConfig.apiUrl + "/examen-complementaire", {
        method: "GET",
      })
        .then((response) => response.json())
        .then((json) => {
          return json.examencomplementaire;
        });
    },
    groupBy: function (collection) {
      const groups = collection.reduce((groups, item) => {
        const group = groups[item.reference] || [];
        group.push(item);
        groups[item.reference] = group;

        return groups;
      }, {});
      return groups;
    },
  },

  validations: {
    form: {
      complementaire: {
        //
      },
      complementaires: [],
      examen_complementaire: {
        //
      },
      prix: {
        //
      },
      institution: {
        required,
      },
    },
  },
  created() {
      this.handleView();
      window.addEventListener('resize', this.handleView);
  },
  mounted() {
    window.addEventListener('resize', this.handleView());
    // Fetch user institution list
    this.getUserInstitutions();

    // Fetch institution list
    this.getInstitutions();

    new SlimSelect({
      select: "#institution",
      placeholder: "Select institution",
      limit: 1,
    });

    this.getComplementaire();

    this.getPrice().then((data) => {
      this.defaultExamenPrix = data;
      this.pageOptions.push({value:data.length, text: 'Afficher tous'})
    });

    var btn = $("#button");

    $(window).scroll(function () {
      if ($(window).scrollTop() > 300) {
        btn.addClass("show");
      } else {
        btn.removeClass("show");
      }
    });

    btn.on("click", function (e) {
      e.preventDefault();
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        "300"
      );
    });
  },
};
</script>
